import React, { useEffect, useState } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { RouteAccessControl } from '../../Config/RouteConfig';
import { CommonService } from '../../Service/CommonService';

interface RouteGuardProps {
  exact?: boolean;
  path: string;
  children: React.ReactNode;
}

const RouteGuard: React.FC<RouteGuardProps> = ({ exact, path, children }) => {
  const location = useLocation();
  const cookies = new Cookies();
  const userRole = cookies.get('userRole');
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectPath, setRedirectPath] = useState<string>('');

  useEffect(() => {
    const currentPath = location.pathname;
    
    if (!userRole) {
      return;
    }

    // Check if this is an impersonation session (super admin logged in as another user)
    const isImpersonating = localStorage.getItem('loginAsUser') === 'yes';

    const isAllowed = RouteAccessControl.isRouteAllowed(currentPath, userRole, isImpersonating);
    
    if (!isAllowed) {
      const fallback = RouteAccessControl.getFallbackPath(currentPath, userRole);
      const message = RouteAccessControl.getAccessDeniedMessage(currentPath);
      
      CommonService.Toast.fire({
        icon: 'error',
        text: message
      });
      
      if (fallback) {
        setRedirectPath(fallback);
        setShouldRedirect(true);
      }
    }
  }, [location.pathname, userRole]);

  if (shouldRedirect && redirectPath) {
    return <Redirect to={redirectPath} />;
  }

  return (
    <Route exact={exact} path={path}>
      {children}
    </Route>
  );
};

export default RouteGuard;
